<template>
  <div class="layout">
    <Menu :menuWidth="width" v-if="!['/screen'].includes($route.path)" />

    <div class="main" v-if="!['/screen'].includes($route.path)">
      <Top :menuWidth="width" @changeMenu="changeMenu($event)" />

      <div class="content">
        <transition enter-active-class="animated fadeInRight">
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeInRight"
      v-if="['/screen'].includes($route.path)"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { Menu, Top } from './components'

export default {
  data() {
    return {
      width: '200px'
    }
  },
  components: {
    Menu,
    Top
  },
  watch: {
    $route() {
      console.log(this.$route.meta, 'llllllllllll')
    }
  },
  methods: {
    changeMenu(val) {
      this.width = val == '200px' ? '64px' : '200px'
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  height: 100%;

  // main
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .content {
      flex: 1;
      width: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>
